export default __webpack_public_path__ + "static/digital-media-2c3a80caeccf536c354081fab10faac8.png";